import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-brand-surface border-t border-brand-border mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-outfit font-semibold text-white mb-4">
              Proxy <span className="text-violet-600">Magic</span>
            </h3>
            <p className="text-zinc-400 text-sm">
              High-quality custom MTG cards for testing and casual play.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-medium mb-4">Products</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/shop?category=base" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Base Cards
                </Link>
              </li>
              <li>
                <Link to="/shop?category=elite" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Elite Cards
                </Link>
              </li>
              <li>
                <Link to="/shop?category=foil" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Foil Cards
                </Link>
              </li>
              <li>
                <Link to="/shop?category=custom" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Custom Cards
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="text-white font-medium mb-4">Account</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  My Orders
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Register
                </Link>
              </li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-white font-medium mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-white text-sm transition-colors">
                  Contact Us
                </Link>
              </li>
              <li className="text-zinc-400 text-sm pt-2">
                Custom playtest cards only
              </li>
              <li className="text-zinc-400 text-sm">
                Not for tournament use
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-border mt-8 pt-8 text-center text-zinc-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Proxy Magic. All rights reserved.</p>
          <p className="mt-2 text-xs">High-quality custom cards for testing and casual play.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
